import React, { useState } from 'react';
import { Box, Input, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../../store';
import { getNumberValue } from '../../../../../utils';
import CurrencySelect from '../../../../../components/shared/CurrencySelect';
import MyTableCell from '../../../../../components/material-ui/adaptive/MyTableCell';
import BtnPlus from '../../../../../components/bonus/ui/BtnPlus';
import { styleCellTitle } from '../../../../../components/bonus/ui/styles';

export default function BonusCurrency({ currencies, groupId, changeFieldValues }) {
  const { t } = useTranslation();
  const groupHash = useAppSelector((state) => state.user.group.hash[groupId]);
  const currencyDefault = groupHash?.currency || Object.keys(currencies || [])?.[0];

  const [selectCurrency, setSelectCurrency] = useState(currencyDefault);
  const currentValue = currencies?.[selectCurrency];

  const changeField = (name, value) => {
    const newValue = getNumberValue(value);
    changeFieldValues(name, newValue, selectCurrency);
  };

  const onPlusClick = () => {
    changeField('amount', 1);
    changeField('wager', 1);
    changeField('cashout', 1);
  };

  return (
    <Box my={2}>
      <TableContainer sx={{ minWidth: { sm: '350px' } }}>
        <Table>
          <TableHead>
            <TableRow>
              <MyTableCell style={styleCellTitle}>{t('Currency')}</MyTableCell>
              <MyTableCell style={styleCellTitle}>{t('Bonus amount')}</MyTableCell>
              <MyTableCell style={styleCellTitle}>{t('Wager')}</MyTableCell>
              <MyTableCell style={styleCellTitle}>{t('Cashout')}</MyTableCell>
              <MyTableCell style={styleCellTitle}>
                <CurrencySelect
                  id={'currencies_start_bot'}
                  value={selectCurrency}
                  setValue={setSelectCurrency}
                />
              </MyTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentValue && Object.keys(currentValue).length ? (
              <TableRow>
                <MyTableCell>
                  <b>{selectCurrency}</b>
                </MyTableCell>
                <MyTableCell>
                  <Input
                    value={currentValue?.amount}
                    onChange={(e) => changeField('amount', e.target.value)}
                    type="number"
                    inputProps={{ min: 1 }}
                  />
                </MyTableCell>
                <MyTableCell>
                  <Input
                    value={currentValue?.wager}
                    onChange={(e) => changeField('wager', e.target.value)}
                    type="number"
                    inputProps={{ min: 0 }}
                  />
                </MyTableCell>
                <MyTableCell>
                  <Input
                    value={currentValue?.cashout}
                    onChange={(e) => changeField('cashout', e.target.value)}
                    type="number"
                    inputProps={{ min: 1 }}
                  />
                </MyTableCell>
                <MyTableCell></MyTableCell>
              </TableRow>
            ) : (
              <TableRow>
                <MyTableCell></MyTableCell>
                <MyTableCell></MyTableCell>
                <MyTableCell></MyTableCell>
                <MyTableCell></MyTableCell>
                <MyTableCell>
                  <BtnPlus onPlusClick={onPlusClick} />
                </MyTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
